<template>
  <f-dashboard-content-wrapper>
    <div class="is-grid">
      <div class="is-col-3">
        <simple-stat 
          label="Gain total"
          :data="stats.range.cashback"
          symbol="€"
        ></simple-stat>
      </div>

      <div class="is-col-3">
        <simple-stat 
          label="Codes à l'inscription"
          :data="stats.range.signup"
        ></simple-stat>
      </div>

      <div class="is-col-3">
        <simple-stat 
          label="Utilisateurs convertis" 
          :data="stats.range.cashbackUsers"
        ></simple-stat>
      </div>

      <div class="is-col-3">
        <simple-stat 
          label="Conversion" 
          :data="stats.range.conversionRate"
          symbol="%"
        ></simple-stat>
      </div>

      <div class="is-col-3">
        <simple-stat 
          label="Trimestre en cours"
          :data="stats.currentQuarter.cashback"
          symbol="€"
        ></simple-stat>
      </div>

      <div class="is-col-3">
        <simple-stat 
          :label="stats.quarterMinus1.quarter"
          :data="stats.quarterMinus1.cashback"
          symbol="€"
        ></simple-stat>
      </div>

      <div class="is-col-3">
        <simple-stat 
          :label="stats.quarterMinus2.quarter"
          :data="stats.quarterMinus2.cashback"
          symbol="€"
        ></simple-stat>
      </div>

      <div class="is-col-3">
        <simple-stat 
          :label="stats.quarterMinus3.quarter"
          :data="stats.quarterMinus3.cashback"
          symbol="€"
        ></simple-stat>
      </div>
    </div>

    <f-list
      :store="storeId"
      :query="query"
    >
      <template #list-actions>
        <div class="is-grid is-aligned m-vertical-12">
          <div class="is-col-8 is-aligned">
            <f-select 
              v-model="codeFilters"
              :options="codeOptions"
              label="label"
              value="value"
              placeholder="Codes"
              size="small"
              multiple
            ></f-select>

            <f-datepicker 
              v-model="fromRange"
              placeholder="Du..."
              format="MMMM YYYY"
              granularity="months"
              start-of="month"
              size="small"
            ></f-datepicker>

            <f-datepicker 
              v-model="toRange"
              placeholder="Au..."
              format="MMMM YYYY"
              granularity="months"
              end-of="month"
              size="small"
            ></f-datepicker>
          </div>
        </div>
      </template>

      <template #list-header>
        <cashback-header
          v-model:signup="signup"
          v-model:firstSubscription="firstSubscription"
          v-model:subscription="subscription"
        ></cashback-header>
      </template>

      <template #list-item="{ item }">
        <cashback-item
          :cashback="item"
        ></cashback-item>
      </template>

      <template #pagination-custom="{ pagination }">
        <div class="is-aligned-right m-left-20">
          <p>
            <small>
              <span class="is-medium">{{ pagination.total }}</span> résultats
            </small>
          </p>
        </div>
      </template>
    </f-list>

  </f-dashboard-content-wrapper>
</template>

<script>
  import { ref, computed, watch, reactive, toRefs } from 'vue'
  import dayjs from 'dayjs'
  import router from '@core/router'
  import usePartnersStats from '@composables/statistics/use-partners-stats'
  import CashbackItem from './item/cashback-item'
  import CashbackHeader from './header/cashback-header'
  import SimpleStat from '@components/statistics/simple-stat'

  export default {
    setup () {
      const partnerId = computed(() => router.currentRoute.value.params.partner_id)
      const storeId = ref('@admin/cashbacks')

      const fromRange = ref(null)
      const toRange = ref(null)

      const stats = computed(() => 
        usePartnersStats(partnerId.value, {
          from: fromRange.value,
          to: toRange.value,
        })
      )   
      
      const state = reactive({
        signup: 0,
        firstSubscription: 0,
        subscription: -1,
        codeFilters: [],
        codeOptions: computed(() => stats.value.codes),
      })

      const query = computed(() => {
        const filters = {
          partner_id: partnerId.value,
        }
        const sort = {}

        if (state.firstSubscription) {
          sort['dates.first_subscription'] = state.firstSubscription
        }

        if (state.signup) {
          sort['dates.signup'] = state.signup
        }

        if (state.subscription) {
          sort['dates.subscription'] = state.subscription
        }

        state.codeFilters
          .map(filter => {
            return state.codeOptions.find(
              item => item.value === filter
            )
          })
          .filter(filter => !!filter)
          .forEach(filter => {
            if (!filters[filter.key]) {
              filters[filter.key] = { $in: [] }
            }
            filters[filter.key].$in.push(filter.value)
          })

        if (fromRange.value) {
          filters['dates.subscription'] = {
            $gte: fromRange.value.toISOString(),
          }

          if (toRange.value) {
            filters['dates.subscription'].$lte = dayjs(toRange.value).endOf('month').toISOString()
          }
        }

        return {
          ...filters,
          $sort: sort,
        }
      })

      watch(() => partnerId.value, newValue => {
        state.codeFilters = []
        fromRange.value = null
        toRange.value = null
      })

      return { 
        ...toRefs(state),
        fromRange,
        toRange,
        stats,
        storeId,
        query,
      }
    },

    components: {
      CashbackItem,
      CashbackHeader,
      SimpleStat,
    },
  }
</script>